import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from './../../auth/auth.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UtilsService } from '../../services/utils.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import {CognitoService} from "../../services/cognito.service";
import { DocumentsService } from 'src/app/services/document.service';
import { v4 as uuidv4 } from 'uuid';
declare var $: any;


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {

  formRestorePaswordCode: FormGroup;

  checkCode: boolean = false;

  userEmail: any;

  Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });

  constructor(private fb  : FormBuilder,
    private auth: AuthService,
    private router: Router,
    private utilService: UtilsService,
    private documentService: DocumentsService,
    private cognitoService: CognitoService )
  {

    this.formRestorePaswordCode = this.fb.group
    ({
    // email: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]],
    code: ['', [Validators.required]],
    password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/)]],
    confirmPassword: ['', Validators.required],
    },{ validators: this.checkPasswords as any } );
  }

  print()
  {
    const email = this.formRestorePaswordCode;
    console.log('Valor del email:', email);
  }

  updatePassword()
  {
    if(!this.checkPasswords(this.formRestorePaswordCode))
    {
      this.cognitoService.forgotPasswordSubmit(this.userEmail, this.formRestorePaswordCode.value.code, this.formRestorePaswordCode.value.password).then((data) => {
        this.checkCode = false;
        Swal.fire({
          title: 'Se ha reestablecido la contraseña correctamente.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        this.router.navigate(['/login']);
      }).catch((error) => {
        this.switchError(error.code);
      })
    }
    else
    {
      this.Toast.fire({
        icon: "error",
        title: "Las contraseñas no coinciden"
      });
    }

  }

  sendConfirmationCode(){

    this.cognitoService.forgotPassword(this.formRestorePaswordCode.value.email).then((data) => {
      this.checkCode = true;
      this.userEmail = this.formRestorePaswordCode.value.email;
      this.formRestorePaswordCode.get('email').disable();

      this.Toast.fire({
        icon: "success",
        title: "Se ha enviado el código de verificación!"
      });

    }).catch((error) => {
      this.switchError(error.code);
    });

  }

  private switchError(code: string) {

    let message;
    
    switch (code) {
      case "NotAuthorizedException":
        message = 'Creedenciales inválidas';
        break;

      case "UsernameExistsException":
        message =  'El usuario ya existe';
        break;

      case "CodeMismatchException":
        message = 'Código de verificación inválido';
        break;

      case "LimitExceededException":
        message = 'Límite de intentos excedido';
        break;

      case "InvalidParameterException":
        message = 'Parámetros inválidos';
        break;
    }
    this.Toast.fire({
      icon: "error",
      title: message
    });
  }

  resendCode()
  {
    this.cognitoService.resendConfirmationCode(this.userEmail).then((data) => {
      
      this.Toast.fire({
        icon: "success",
        title: "Se ha reenviado el código de verificación!"
      });

    }).catch((error) => {
      this.switchError(error.code);
    });

  }

  checkPasswords(group: FormGroup) {
    let pass = group.get('password')?.value;
    let confirmPass = group.get('confirmPassword')?.value;

    return pass === confirmPass ? null : { passwordsDoNotMatch: true }
  }

  ngOnInit() {
  }

}
